import { Navigate } from "react-router-dom";
import { isAuthenticated, clearSession } from "../helper/session";

/**
 * Landing/unknown-URL target.
 *
 * Previously the catch-all sent every unknown path (including the bare domain
 * "/") to the sign-in FORM, so an admin opening a new tab saw a login screen
 * despite having a valid session and assumed they had been logged out.
 * Authenticated users now land on /users; only anonymous visitors see sign-in.
 */
export const HomeRedirect = () =>
  isAuthenticated() ? (
    <Navigate to="/users" replace />
  ) : (
    <Navigate to="/authentication/sign-in" replace />
  );

/**
 * Real sign-out: clear the session cookies, then show the sign-in screen.
 * The sidebar's "تسجيل الخروج" item points here; before, it navigated to the
 * sign-in page without clearing anything, so the user was never signed out.
 */
export const SignOut = () => {
  // Clear synchronously, before the redirect renders. With useEffect the
  // <Navigate> child's effect fired first, so the sign-in page mounted while
  // the cookies still existed and bounced the user back to /users for one
  // navigation. clearSession() is idempotent, so running it during render
  // (twice under StrictMode) is safe.
  clearSession();
  return <Navigate to="/authentication/sign-in" replace />;
};
